<template>
  <ul style="padding-top:14px;">
    <li v-for="node in nodes" :key="node.id" v-if="node.orderId">
      
      <router-link 
      :class="node.orderId !== order.orderId ? 'has-text-link' : 'active'" 
      :to="{ name: 'order-list', query: { orderId: node.orderId } }" 
      style="text-align:left;">

        <p>Status: {{ node.status }}</p>
        <p>Number: {{ node.orderId }}</p>
        <p>Activity Type: {{ node.activityType }}</p>

      </router-link>

      <order-family-tree-nodes
        :order="order"
        :nodes="node.children"
        v-if="node.children.length > 0"
      />
    </li>
  </ul>
</template>

<script>
import OrderFamilyTreeNodes from "./OrderFamilyTreeNodes";

export default {
  name: "order-family-tree-nodes",
  props: {
    order: {
      required: true
    },
    nodes: {
      type: Array,
      default: () => []
    }
  },
  components: {
    OrderFamilyTreeNodes
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Order/OrderFamilyTreeNodes.vue